import React, { useState, useEffect, useCallback } from "react";
import AsyncSelect from "react-select/async";
import { Controller } from "react-hook-form";
import { getSupplierContactList } from "../../../services/Settings/dropdown";

function ucfirst(str) {
  if (!str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1);
}

const SupplierContact = ({
  control,
  name,
  onSelectChange,
  disabled,
  target,
  placeholder,
  clearable,
  ledgerId,
  refreshKey,
}) => {
  const [options, setOptions] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [inputValue, setInputValue] = useState("");

  console.log(`ledgerId`, ledgerId);
  

  // ✅ Fetch only if ledgerId exists
  const fetchOptions = useCallback(
    async (search = "", pageNum = 1, concat = false) => {
      if (!ledgerId) {
        setOptions([]);
        return [];
      }

      const res = await getSupplierContactList({
        searchText: search,
        ledger_id: ledgerId,
        page: pageNum,
      });

      const dataArr = res?.data || [];
      const mapped = dataArr.map(dta => ({
        label: dta?.supplier_contact_name ? ucfirst(dta.supplier_contact_name) : "",
        value: dta.id,
        ...dta,
      }));

      setHasMore((res?.lastPage || 1) > pageNum);

      if (concat) {
        setOptions(prev => [...prev, ...mapped]);
        return [...options, ...mapped];
      } else {
        setOptions(mapped);
        return mapped;
      }
    },
    [ledgerId]
  );

  // ✅ Async load handler
  const loadOptions = useCallback(
    (input, callback) => {
      if (!ledgerId) {
        callback([]);
        return;
      }
      setInputValue(input);
      setPage(1);
      fetchOptions(input, 1, false).then(callback);
    },
    [ledgerId, fetchOptions]
  );

  // ✅ Infinite scroll handler
  const handleMenuScrollToBottom = () => {
    if (hasMore && ledgerId) {
      const nextPage = page + 1;
      setPage(nextPage);
      fetchOptions(inputValue, nextPage, true);
    }
  };

  // ✅ Reset when ledger or refresh changes
  useEffect(() => {
    setOptions([]);
    setPage(1);
    setHasMore(true);
    setInputValue("");
    if (ledgerId) fetchOptions("", 1, false);
  }, [ledgerId, refreshKey, fetchOptions]);

  // ✅ Input change
  const handleInputChange = (input, { action }) => {
    if (action === "input-change") setInputValue(input);
    if (action === "input-clear") {
      setInputValue("");
      setPage(1);
      if (ledgerId) fetchOptions("", 1, false);
    }
    return input;
  };

  // ✅ On change
  const handleChange = (selected, onChange) => {
    onChange(selected);
    if (onSelectChange) onSelectChange(selected);
  };

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, ref, value } }) => (
        <AsyncSelect
          key={ledgerId || "no-ledger"} // re-render when ledger changes
          defaultOptions={ledgerId ? options : []}
          loadOptions={loadOptions}
          placeholder={placeholder || "Select Contact"}
          inputRef={ref}
          onChange={selected => handleChange(selected, onChange)}
          value={value}
          isClearable={clearable}
          isDisabled={disabled || !ledgerId}
          classNamePrefix="react-select"
          className="elevate-dropdown"
          menuPortalTarget={document.querySelector(target || "body")}
          styles={{
            menuPortal: base => ({ ...base, zIndex: 9999 }),
          }}
          onMenuScrollToBottom={handleMenuScrollToBottom}
          onInputChange={handleInputChange}
        />
      )}
    />
  );
};

export default SupplierContact;
